import { MouseEvent } from 'react';
import { Button, Box, Typography, Theme } from '@mui/material';
import {
  Icon24ResponseTime,
  Icon24CalendarAndAvailability,
  Icon24Search,
} from '@care/react-embrace-icons';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';

import { useResponsive } from '@/components/hooks/useResponsive';

type SeoConversionBoxProps = {
  enrollmentURL: string;
};

export const SeoConversionBox = ({ enrollmentURL }: SeoConversionBoxProps) => {
  const { isSmallViewport } = useResponsive();
  const ctaList = [
    {
      icon: <Icon24ResponseTime />,
      label: 'Right Now',
      intent: 'rightNow',
    },
    {
      icon: <Icon24CalendarAndAvailability />,
      label: 'Within a month',
      intent: 'withInMonth',
    },
    {
      icon: <Icon24Search />,
      label: 'Just browsing',
      intent: 'justBrowsing',
    },
  ];

  const handleCareButton = (e: MouseEvent) => {
    const amplitudeData = {
      cta_location: 'header',
      cta_text: (e.target as HTMLElement).textContent?.toString(),
      cta_type: 'button',
    };

    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, amplitudeData);
  };

  return (
    <Box
      sx={{
        py: { xs: 6, sm: 8 },
        px: 3,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'background.accent.accent1',
      }}>
      <Typography
        mb={4}
        mt={0}
        textAlign="center"
        component="h3"
        variant={isSmallViewport ? 'h2' : 'display3'}>
        When do you want a job?
      </Typography>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection={{ xs: 'column', sm: 'row' }}
        columnGap={{ sm: 3 }}>
        {ctaList.map((item) => (
          <Button
            key={item.intent}
            component="a"
            href={`${enrollmentURL}&intent=${item.intent}`}
            variant="outlined"
            color="secondary"
            size="large"
            sx={(theme: Theme) => ({
              minWidth: { xs: '327px', sm: 'auto' },
              border: `1px solid ${theme.palette.brand.main}`,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', sm: 'center' },
              whiteSpace: 'nowrap',
            })}
            fullWidth
            onClick={handleCareButton}
            rel="nofollow">
            <Box
              sx={{
                mr: { sm: 1 },
                display: 'flex',
                alignItems: 'center',
              }}>
              {item.icon}
            </Box>
            <Typography
              variant="inherit"
              sx={{
                flex: 1,
                textAlign: 'center',
              }}>
              {item.label}
            </Typography>
          </Button>
        ))}
      </Box>
    </Box>
  );
};
